import React from 'react';
import Avatar from 'react-avatar';
import SocialBar from '../../components/social-bar';

const AnalyticsInfluencerCard = ({ trackedAsset, influencerProfile }) => {
  if (!trackedAsset || !influencerProfile) return null;
  const youtubeCount = influencerProfile.aggregateYoutubeChannelStatistics ? influencerProfile.aggregateYoutubeChannelStatistics.subscriberCount : 0;
  const facebookCount = influencerProfile.facebookStatistics ? influencerProfile.facebookStatistics.likes : 0;
  const twitterCount = influencerProfile.twitterStatistics ? influencerProfile.twitterStatistics.followersCount : 0;
  const instagramCount = 0;
  return (
    <div className="influencer-card">
      <div className="flex-item">
        <Avatar name={trackedAsset.influencerName} round={true} size={100} src={influencerProfile.thumbnail} />
      </div>
      <div className="flex-item">
        <h2>{ trackedAsset.influencerName }</h2>
        <p className="light">{ influencerProfile.countryCode }</p>
      </div>
      <div className="flex-spacer">
        <SocialBar
          influencerId={influencerProfile.id}
          data={[
            {
              channel: 'youtube',
              count: youtubeCount,
            },
            {
              channel: 'facebook',
              count: facebookCount,
            },
            {
              channel: 'instagram',
              count: instagramCount,
            },
            {
              channel: 'twitter',
              count: twitterCount,
            },
          ]}
          dataTotal={
            youtubeCount + facebookCount + instagramCount + twitterCount
          }
        />
      </div>
      <div className="flex-item">
        <h2>{influencerProfile.totalSocialReach.toLocaleString()}</h2>
        <p className="light">Total reach</p>
      </div>
    </div>
  );
};

export default AnalyticsInfluencerCard;



/** WEBPACK FOOTER **
 ** ./src/components/analytics-influencer-card/index.js
 **/